import { render } from "./LinkAnalyticsPractice.vue?vue&type=template&id=2b82ff2b&scoped=true"
import script from "./LinkAnalyticsPractice.vue?vue&type=script&lang=js"
export * from "./LinkAnalyticsPractice.vue?vue&type=script&lang=js"

import "@/css/components/link-analytics-practice.css?vue&type=style&index=0&id=2b82ff2b&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b82ff2b"]])

export default __exports__